import { render } from "./Blocks2.vue?vue&type=template&id=4f23a5d3"
import script from "./Blocks2.vue?vue&type=script&lang=js"
export * from "./Blocks2.vue?vue&type=script&lang=js"

import "./Blocks2.vue?vue&type=style&index=0&id=4f23a5d3&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Blocks2.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4f23a5d3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4f23a5d3', __exports__)) {
    api.reload('4f23a5d3', __exports__)
  }
  
  module.hot.accept("./Blocks2.vue?vue&type=template&id=4f23a5d3", () => {
    api.rerender('4f23a5d3', render)
  })

}


export default __exports__